/**
 * Response Builder Application Entry Point
 * 
 * Per PHASE_B_WORK_ORDERS.md B2:
 * - Import @threadlock/tokens exactly once at top-level
 * - Initialize Firebase
 * - Mount React application
 */

import React from 'react';
import ReactDOM from 'react-dom/client';

// Import tokens exactly once at top-level (MANDATORY per Phase B)
import '@threadlock/tokens';

import App from './App';
import './index.css';

// Import Firebase instances (initialized in firebase-init.ts to avoid circular deps)
import { auth, db } from './firebase-init';

// Re-export for components that import from main.tsx
export { auth, db };

// Mount application
ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
